import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <div className="flex text-brand-gold mr-1" data-id="element-209" data-mp="1c1yqnqwwoc2z">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-210" data-mp="y6mncv4opdag" data-mpi={i} />)}
        </div>,
    text: '4.9 · 600+ Google Reviews'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-211" data-mp="1qyg1mh16nop0" />,
    text: 'ASE-Certified Technicians'
  }, {
    icon: <CheckIcon className="w-5 h-5 text-brand-dark mr-2" data-id="element-212" data-mp="1uygh8500q5xn" />,
    text: '2-Year / 24,000-Mile Warranty'
  }];
  return <div className="py-4 px-4 border-y border-brand-accentHover shadow-inner bg-[#c8b4a4]" data-id="element-213" data-mp="1h1l1jtp9hg8m">
      <div className="max-w-6xl mx-auto" data-id="element-214" data-mp="1m0ef1m4jt78s">
        <div className="flex flex-wrap justify-center items-center gap-y-4 gap-x-8 md:gap-x-16" data-id="element-215" data-mp="5jsdes5htwb8">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center text-brand-dark font-bold text-sm md:text-base text-center" data-id="element-216" data-mp="akg57g1jqh6i" data-mpi={index}>
              {item.icon}
              <span data-id="element-217" data-mp="1pf4qwfwdvq63">{item.text}</span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}